import { render, staticRenderFns } from "./value-proposition.vue?vue&type=template&id=2f3b251c&"
import script from "./value-proposition.vue?vue&type=script&lang=js&"
export * from "./value-proposition.vue?vue&type=script&lang=js&"
import style0 from "./value-proposition.vue?vue&type=style&index=0&id=2f3b251c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports